import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {
    aggiungiStrutturaClasseTipoImpExpDatiApi,
    getClassiTipiImpExpDatiApi
} from "./services/TipiImpExpDatiServices";
import ModificaStrutturaClasseImpExpView from "./ModificaStrutturaClasseImpExpView";

export default function ModificaStrutturaClasseImpExpController() {

    const [optionsClass, setOptionsClass] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getClassiKpi() {
        const response = await getClassiTipiImpExpDatiApi();
        setOptionsClass(response.data.data);
    }

    async function salvaClasseTipoImpExpDati(values) {
        const response = await aggiungiStrutturaClasseTipoImpExpDatiApi(values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    useEffect(() => {
        getClassiKpi();
    }, []);

    const SignupSchema = Yup.object().shape({
        id_classe_tipo_imp_exp: Yup.string().required(translate('Questo campo è obbligatorio')),
        id_classe_tipo_imp_exp_madre: Yup.string().required(translate('Questo campo è obbligatorio')),
    });

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initailValuesForm = {
        id_struttura_classe_tipo_imp_exp: '',
        id_classe_tipo_imp_exp: '',
        id_classe_tipo_imp_exp_madre: ''
    };

    return (
        <ModificaStrutturaClasseImpExpView
            translate={translate}
            history={history}
            formikRef={formikRef}
            setShow={setShow}
            show={show}
            modalMsg={modalMsg}
            SignupSchema={SignupSchema}
            optionsClass={optionsClass}
            salvaClasseTipoImpExpDati={salvaClasseTipoImpExpDati}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initailValuesForm={initailValuesForm}
        />
    );
}